import { PropsWithChildren } from 'react';

import { useOptionalUser } from '@frontend/utils';

import { OnboardingView } from './onboarding.view';
import { useOnboarding } from './use-onboarding';

export const OnboardingProvider = (props: PropsWithChildren) => {
  const { user } = useOptionalUser();

  if (!user) {
    return <>{props.children}</>;
  }

  return (
    <OnboardingForLoggedInUser>{props.children}</OnboardingForLoggedInUser>
  );
};

const OnboardingForLoggedInUser = (props: PropsWithChildren) => {
  const onboarding = useOnboarding();

  if (!onboarding.shouldOnboard) {
    return <>{props.children}</>;
  }

  return <OnboardingView />;
};
